import React, { ReactNode } from "react";
import HtmlToReact, { ProcessingInstruction } from "html-to-react";
import { absoluteURL } from "../../util/UrlHelper";
import Anchor from "../Router/Anchor";

interface SafeHtmlProps
{
    html: string | undefined;
    isValidNode?: () => boolean;
    instructions?: ProcessingInstruction[];
}

const SafeHtml: React.FunctionComponent<SafeHtmlProps> = (props) =>
{
    if (!props.html)
    {
        return null;
    }

    const HtmlToReactParser = HtmlToReact.Parser;
    const htmlToReactParser = new HtmlToReactParser();

    const isValidNode = props.isValidNode ? props.isValidNode : () =>
    {
        return true;
    };

    // Order matters. Instructions are processed in the order they're defined
    const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
    const processInstructions: ProcessingInstruction[] = [
        // Sample of how to rewrite a text value
        // {
        //     // Custom <h1> processing
        //     shouldProcessNode: function (node)
        //     {
        //         return node.parent && node.parent.name && node.parent.name === "h1";
        //     },
        //     processNode: function (node, children)
        //     {
        //         return node.data.toUpperCase();
        //     }
        // },
        {
            // Custom img rewrite
            shouldProcessNode: function (node)
            {
                if (node.name && node.name === "img")
                {
                    return node.attribs.src && node.attribs.src.startsWith("/media");
                }
                return false;
            },
            processNode: function (node, children)
            {
                const src = absoluteURL(node.attribs.src as string);
                node.attribs.src = src;
                return processNodeDefinitions.processDefaultNode(node, children);
            }
        },
        {
            // Custom img rewrite
            shouldProcessNode: function (node)
            {
                return node.name && node.name === "a";
            },
            processNode: function (node, children)
            {
                const href = node.attribs.href || "";
                const title = node.attribs.title || "";
                const id = node.attribs.id || "";
                return (
                    <Anchor to={href} title={title} id={id}>
                        {children}
                    </Anchor>
                ) as ReactNode;
            }
        },
        {
            // Anything else
            shouldProcessNode: function (node)
            {
                return true;
            },
            processNode: processNodeDefinitions.processDefaultNode
        }
    ];

    const parsed = htmlToReactParser.parseWithInstructions(props.html, isValidNode, processInstructions);

    return (<>{parsed}</>);
};

export default SafeHtml;
